import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";

import {
  getWorkspaceAccess,
  workspaceAccessQueryKey,
  type WorkspaceKey,
} from "./api";

export function useWorkspaceAccess(projectId?: string | number) {
  const query = useQuery({
    queryKey: workspaceAccessQueryKey(projectId ?? "no-project"),
    queryFn: () => getWorkspaceAccess(projectId!),
    enabled: Boolean(projectId),
    staleTime: 60_000,
  });

  const canAccess = useCallback(
    (workspace: WorkspaceKey) => query.data?.access[workspace] === true,
    [query.data?.access]
  );

  return {
    ...query,
    canAccess,
  };
}
